import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { useEffect, useRef, useState } from "react";
import { Fetch } from "../../shared/Fetch";

interface IProps {
    toast?: any,
    consultant?: number,
    open?: boolean
}

interface ITableData {
    consultant_ID?: number,
    consultant_Name?: string,
    vendor_Company_Name?: string,
    req_Job_Title?: string,
    req_ID?: number,
    recruiter?: string,
    sales?: string,
    subDateTime?: Date,
    status?: string,
}

export const EciSub = (props: IProps) => {
    const [tableData, setTableData] = useState({ tableData: [], loading: false } as { tableData: Array<ITableData>, loading: boolean });
    const dt = useRef<any>(null);

    const LoadEciSub = async () => {
        setTableData({ tableData: tableData.tableData, loading: true });
        const response = await Fetch("FindResume/getsubeci", "GET", null, `ConsultantID=${props.consultant}`, props.toast);
        if (response) {
            const data: ITableData[] = await response.json();
            console.log(data);
            setTableData({ tableData: data, loading: false });
        } else {
            setTableData({ tableData: tableData.tableData, loading: false });
        }
    }

    const header = () => {
        return (
            <>
            </>
        );
    }

    useEffect(() => {
        if (props.open === true) {
            LoadEciSub();
        }
    }, [props.open]);
    return (
        <>
            <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0" }}
                ref={dt} size="small"
                value={tableData.tableData} lazy dataKey="id"
                emptyMessage="No Pages found."
                header={header}
                loading={tableData.loading}
            >
                {/* <Column field="consultant_ID" header="consultant_ID" sortable /> */}
                <Column field="sn" header="SN" body={(rowData, options) => options.rowIndex + 1} />
                <Column field="consultant_Name" header="Consultant Name" sortable />
                <Column field="vendor_Company_Name" header="vendor Company Name" sortable />
                <Column field="req_Job_Title" header="Job Title" sortable />
                <Column field="req_ID" header="Req ID" sortable />
                <Column field="recruiter" header="Recruiter" sortable />
                <Column field="sales" header="Sales" sortable />
                <Column field="subDateTime" header="Sub Date" sortable />
                <Column field="status" header="Status" sortable />
            </DataTable>
        </>
    );
}